// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RateNowModal_rateNowForm__65\\+\\+3 {
  width: 100%;
  display: block;
  overflow-y: hidden;
}

.RateNowModal_cardContainer__LDTOW {
  width: 100%;
  display: flex;
  align-items: center;
}

.RateNowModal_cardContent__g16b\\+ {
  display: flex;
  gap: 16px;
  width: 100%;
  align-items: center;
}

.RateNowModal_cardImageWrapper__75Pma {
  flex-shrink: 0;
  max-width: 140px;
  width: 100%;
  max-height: 100px;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}
.RateNowModal_cardImageWrapper__75Pma .RateNowModal_churrosImage__PdQMI {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.RateNowModal_cardInfoWrapper__iWHiv {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
.RateNowModal_cardInfoWrapper__iWHiv .RateNowModal_cardCategory__qTycu {
  font: var(--body-font-four);
  color: var(--secondary-Text);
  font-weight: 500;
  margin-bottom: 4px;
}
.RateNowModal_cardInfoWrapper__iWHiv .RateNowModal_cardTitle__05jPE {
  font: var(--body-font-one);
  color: var(--primary-Text);
  font-weight: 600;
  margin-bottom: 12px;
}
.RateNowModal_cardInfoWrapper__iWHiv .RateNowModal_cardLocationBox__yQLLV {
  display: flex;
  align-items: center;
  gap: 4px;
  border-top: 1px solid var(--border);
  padding-top: 12px;
}
.RateNowModal_cardInfoWrapper__iWHiv .RateNowModal_cardLocationBox__yQLLV .RateNowModal_churrosLocationIcon__on1Ce {
  width: 16px;
  height: 16px;
  display: block;
}
.RateNowModal_cardInfoWrapper__iWHiv .RateNowModal_cardLocationBox__yQLLV .RateNowModal_cardAddress__Bo1Wu {
  font: var(--body-font-four);
  color: var(--secondary-Text);
  font-weight: 400;
}

.RateNowModal_ratingBox__ZUXJ- {
  margin: 22px 0px;
}

.RateNowModal_reviewLabel__pVqkp {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  margin-bottom: 4px;
  display: block;
}

.RateNowModal_formControl__B0xMQ {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.RateNowModal_uploadContainer__MP\\+62 {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  align-items: center;
}

.RateNowModal_uploadBox__44k3v {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  width: 120px;
  height: 110px;
  background-color: var(--white);
}
.RateNowModal_uploadBox__44k3v .RateNowModal_hiddenInput__9OJJx {
  display: none;
}
.RateNowModal_uploadBox__44k3v .RateNowModal_content__kQ-S0 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.RateNowModal_uploadBox__44k3v .RateNowModal_content__kQ-S0 img {
  width: 26px;
  height: 26px;
}
.RateNowModal_uploadBox__44k3v .RateNowModal_content__kQ-S0 span {
  text-align: center;
  font: var(--body-font-four);
  color: var(--brand);
  font-weight: 500;
}

.RateNowModal_imagePreview__vw9CM {
  width: 120px;
  height: 110px;
  position: relative;
}
.RateNowModal_imagePreview__vw9CM img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}
.RateNowModal_imagePreview__vw9CM .RateNowModal_closeIconWrapper__GYgTN {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  background-color: var(--black);
  border-radius: 50%;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.RateNowModal_imagePreview__vw9CM .RateNowModal_closeIconWrapper__GYgTN img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: invert(1);
}

@media (max-width: 599px) {
  .RateNowModal_cardImageWrapper__75Pma {
    max-width: 120px;
    max-height: 80px;
  }
  .RateNowModal_cardInfoWrapper__iWHiv .RateNowModal_cardTitle__05jPE {
    font-size: 16px;
    margin-bottom: 8px;
  }
  .RateNowModal_cardInfoWrapper__iWHiv .RateNowModal_cardCategory__qTycu,
  .RateNowModal_cardInfoWrapper__iWHiv .RateNowModal_cardAddress__Bo1Wu {
    font-size: 14px;
  }
  .RateNowModal_cardInfoWrapper__iWHiv .RateNowModal_cardLocationBox__yQLLV {
    padding-top: 8px;
  }
  .RateNowModal_ratingBox__ZUXJ- {
    margin: 14px 0;
  }
  .RateNowModal_formControl__B0xMQ {
    gap: 7px;
  }
  .RateNowModal_uploadBox__44k3v,
  .RateNowModal_imagePreview__vw9CM {
    width: 100px;
    height: 90px;
  }
}
@media (max-width: 480px) {
  .RateNowModal_cardContent__g16b\\+ {
    flex-direction: column;
    align-items: flex-start;
  }
  .RateNowModal_uploadBox__44k3v,
  .RateNowModal_imagePreview__vw9CM {
    width: 80px;
    height: 80px;
  }
  .RateNowModal_content__kQ-S0 {
    gap: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VendorTracker/modal/RateNowModal.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAEI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAAR;;AAIA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AADJ;AAGI;EACI,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;AADR;AAII;EACI,0BAAA;EACA,0BAAA;EACA,gBAAA;EAEA,mBAAA;AAHR;AAOI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mCAAA;EACA,iBAAA;AALR;AAOQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;AALZ;AASQ;EACI,2BAAA;EACA,4BAAA;EACA,gBAAA;AAPZ;;AAYA;EACI,gBAAA;AATJ;;AAYA;EACI,4BAAA;EACA,4BAAA;EACA,kBAAA;EACA,cAAA;AATJ;;AAYA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AATJ;;AAYA;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AATJ;;AAYA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AATJ;AAWI;EACI,aAAA;AATR;AAYI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAVR;AAYQ;EACI,WAAA;EACA,YAAA;AAVZ;AAaQ;EACI,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;AAXZ;;AAgBA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AAbJ;AAeI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAbR;AAiBI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAfR;AAiBQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAfZ;;AAoBA;EAEI;IACI,gBAAA;IACA,gBAAA;EAlBN;EAsBM;IACI,eAAA;IACA,kBAAA;EApBV;EAuBM;;IAEI,eAAA;EArBV;EAyBM;IACI,gBAAA;EAvBV;EA2BE;IACI,cAAA;EAzBN;EA4BE;IACI,QAAA;EA1BN;EA6BE;;IAEI,YAAA;IACA,YAAA;EA3BN;AACF;AA+BA;EACI;IACI,sBAAA;IACA,uBAAA;EA7BN;EAgCE;;IAEI,WAAA;IACA,YAAA;EA9BN;EAiCE;IACI,QAAA;EA/BN;AACF","sourcesContent":[".rateNowForm {\r\n    width: 100%;\r\n    display: block;\r\n    overflow-y: hidden;\r\n}\r\n\r\n.cardContainer {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.cardContent {\r\n    display: flex;\r\n    gap: 16px;\r\n    width: 100%;\r\n    align-items: center;\r\n}\r\n\r\n.cardImageWrapper {\r\n    flex-shrink: 0;\r\n    max-width: 140px;\r\n    width: 100%;\r\n    max-height: 100px;\r\n    height: 100%;\r\n    border-radius: 12px;\r\n    overflow: hidden;\r\n\r\n\r\n    .churrosImage {\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n        border-radius: 12px;\r\n    }\r\n}\r\n\r\n.cardInfoWrapper {\r\n    flex-grow: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    width: 100%;\r\n\r\n    .cardCategory {\r\n        font: var(--body-font-four);\r\n        color: var(--secondary-Text);\r\n        font-weight: 500;\r\n        margin-bottom: 4px;\r\n    }\r\n\r\n    .cardTitle {\r\n        font: var(--body-font-one);\r\n        color: var(--primary-Text);\r\n        font-weight: 600;\r\n\r\n        margin-bottom: 12px;\r\n    }\r\n\r\n\r\n    .cardLocationBox {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 4px;\r\n        border-top: 1px solid var(--border);\r\n        padding-top: 12px;\r\n\r\n        .churrosLocationIcon {\r\n            width: 16px;\r\n            height: 16px;\r\n            display: block;\r\n        }\r\n\r\n\r\n        .cardAddress {\r\n            font: var(--body-font-four);\r\n            color: var(--secondary-Text);\r\n            font-weight: 400;\r\n        }\r\n    }\r\n}\r\n\r\n.ratingBox {\r\n    margin: 22px 0px;\r\n}\r\n\r\n.reviewLabel {\r\n    font: var(--body-font-three);\r\n    color: var(--secondary-Text);\r\n    margin-bottom: 4px;\r\n    display: block;\r\n}\r\n\r\n.formControl {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 24px;\r\n}\r\n\r\n.uploadContainer {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 12px;\r\n    width: 100%;\r\n    align-items: center;\r\n}\r\n\r\n.uploadBox {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border: 1px solid var(--border);\r\n    border-radius: 12px;\r\n    padding: 12px;\r\n    cursor: pointer;\r\n    width: 120px;\r\n    height: 110px;\r\n    background-color: var(--white);\r\n\r\n    .hiddenInput {\r\n        display: none;\r\n    }\r\n\r\n    .content {\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        align-items: center;\r\n        gap: 10px;\r\n\r\n        img {\r\n            width: 26px;\r\n            height: 26px;\r\n        }\r\n\r\n        span {\r\n            text-align: center;\r\n            font: var(--body-font-four);\r\n            color: var(--brand);\r\n            font-weight: 500;\r\n        }\r\n    }\r\n}\r\n\r\n.imagePreview {\r\n    width: 120px;\r\n    height: 110px;\r\n    position: relative;\r\n\r\n    img {\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n        border-radius: 12px;\r\n\r\n    }\r\n\r\n    .closeIconWrapper {\r\n        position: absolute;\r\n        top: -4px;\r\n        right: -4px;\r\n        width: 18px;\r\n        height: 18px;\r\n        cursor: pointer;\r\n        background-color: var(--black);\r\n        border-radius: 50%;\r\n        padding: 2px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        img {\r\n            width: 100%;\r\n            height: 100%;\r\n            object-fit: cover;\r\n            filter: invert(1);\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 599px) {\r\n\r\n    .cardImageWrapper {\r\n        max-width: 120px;\r\n        max-height: 80px;\r\n    }\r\n\r\n    .cardInfoWrapper {\r\n        .cardTitle {\r\n            font-size: 16px;\r\n            margin-bottom: 8px;\r\n        }\r\n\r\n        .cardCategory,\r\n        .cardAddress {\r\n            font-size: 14px;\r\n        }\r\n\r\n\r\n        .cardLocationBox {\r\n            padding-top: 8px;\r\n        }\r\n    }\r\n\r\n    .ratingBox {\r\n        margin: 14px 0;\r\n    }\r\n\r\n    .formControl {\r\n        gap: 7px;\r\n    }\r\n\r\n    .uploadBox,\r\n    .imagePreview {\r\n        width: 100px;\r\n        height: 90px;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .cardContent {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n    }\r\n\r\n    .uploadBox,\r\n    .imagePreview {\r\n        width: 80px;\r\n        height: 80px;\r\n    }\r\n\r\n    .content {\r\n        gap: 4px;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rateNowForm": `RateNowModal_rateNowForm__65++3`,
	"cardContainer": `RateNowModal_cardContainer__LDTOW`,
	"cardContent": `RateNowModal_cardContent__g16b+`,
	"cardImageWrapper": `RateNowModal_cardImageWrapper__75Pma`,
	"churrosImage": `RateNowModal_churrosImage__PdQMI`,
	"cardInfoWrapper": `RateNowModal_cardInfoWrapper__iWHiv`,
	"cardCategory": `RateNowModal_cardCategory__qTycu`,
	"cardTitle": `RateNowModal_cardTitle__05jPE`,
	"cardLocationBox": `RateNowModal_cardLocationBox__yQLLV`,
	"churrosLocationIcon": `RateNowModal_churrosLocationIcon__on1Ce`,
	"cardAddress": `RateNowModal_cardAddress__Bo1Wu`,
	"ratingBox": `RateNowModal_ratingBox__ZUXJ-`,
	"reviewLabel": `RateNowModal_reviewLabel__pVqkp`,
	"formControl": `RateNowModal_formControl__B0xMQ`,
	"uploadContainer": `RateNowModal_uploadContainer__MP+62`,
	"uploadBox": `RateNowModal_uploadBox__44k3v`,
	"hiddenInput": `RateNowModal_hiddenInput__9OJJx`,
	"content": `RateNowModal_content__kQ-S0`,
	"imagePreview": `RateNowModal_imagePreview__vw9CM`,
	"closeIconWrapper": `RateNowModal_closeIconWrapper__GYgTN`
};
export default ___CSS_LOADER_EXPORT___;
